import type { MessageTemplateReportType } from '@gcv/shared';
import { useQuery } from '@tanstack/react-query';

import { DataPointsApi } from 'api/DataPointsApi';
import { DATA_POINTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

/**
 * Data-point catalog for a report type, powering the Builder's "Insert Data Point" picker.
 * Disabled until the bank id and a report type are known (the endpoint 400s on a missing/invalid
 * reportType).
 */
export function useDataPoints(reportType: MessageTemplateReportType | undefined) {
  const dataPointsApi = new DataPointsApi();
  const { userBankId } = useUser();

  const { data: dataPoints, isLoading: isLoadingDataPoints } = useQuery({
    enabled: !!userBankId.length && !!reportType,
    queryKey: [DATA_POINTS_KEY, userBankId, reportType],
    queryFn: () => dataPointsApi.getDataPoints(userBankId, reportType as MessageTemplateReportType),
    meta: {
      snackbarErrorMessage: 'There was an issue loading data points. Please contact support.'
    }
  });

  return { dataPoints, isLoadingDataPoints };
}
